const PATH = {
	HOME: '/',
	SIGNUP: '/signup',
	LOGIN: '/login',
	DASHBOARD: '/dashboard',
	FORM_POPUP: '/form/popup',
	CREATE_FORM_ADMIN: '/form/create',
	JOIN_FORM: '/form/to',
	RESPONSES: '/responses'

};

export default PATH;
